import React, { useState } from "react";
import { useSelector } from "react-redux";
import { CircularProgress } from "@mui/material";
import { SearchableSelect } from "../Common/SearchableSelect";

const ChangeIntegrationStatusModal = ({
  open,
  onClose,
  rowData,
  onSubmit, // function to handle update
}) => {
  const {
    isChangingCompanyIntegrationStatus,
    isGettingIntegrationStatusList,
    integrationStatusList,
  } = useSelector((state) => state.CompanyListReducer);

  const [newStatus, setNewStatus] = useState("");

  const handleSubmit = () => {
    if (!newStatus) return; // simple validation
    onSubmit(rowData._id, newStatus, handleClose);
  };

  const handleClose = () => {
    setNewStatus("");
    onClose();
  };
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-xl p-6">
        {/* Header */}
        <h2 className="text-lg font-semibold mb-4">
          Change Company Integration Status
        </h2>

        {/* Previous Status */}
        <div className="mb-4">
          <label className="block text-sm font-medium mb-1">
            Previous Integration Status
          </label>
          <input
            type="text"
            value={rowData?.integrationStatus || "-"}
            disabled
            className="w-full border rounded-lg px-3 py-2 bg-gray-100 text-gray-500"
          />
        </div>

        {/* New Status */}
        {isGettingIntegrationStatusList ? (
          <div className="flex justify-center items-center h-20">
            <CircularProgress />
          </div>
        ) : (
          <div className="mb-6">
            <label className="block text-sm font-medium mb-1">
              New Integration Status
            </label>
            <SearchableSelect
              value={newStatus}
              onChange={(e) => setNewStatus(e.target.value)}
              className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Select Status</option>
              {integrationStatusList?.map((item) => (
                <option key={item._id} value={item.value}>
                  {item.value}
                </option>
              ))}
            </SearchableSelect>
          </div>
        )}

        {/* Actions */}
        <div className="flex justify-end gap-3">
          <button
            onClick={handleClose}
            className="px-4 py-2 rounded-lg border text-gray-600 hover:bg-gray-100"
          >
            Cancel
          </button>

          <button
            onClick={handleSubmit}
            disabled={!newStatus}
            className={`px-4 py-2 rounded-lg text-white ${
              newStatus
                ? "bg-blue-700 hover:bg-blue-700"
                : "bg-gray-400 cursor-not-allowed"
            }`}
          >
            {isChangingCompanyIntegrationStatus ? "Updating..." : "Update"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChangeIntegrationStatusModal;
